import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
    // Jours
    'Bi (Aujourd\'hui)': {
        translation: 'Aujourd\'hui', translationEn: 'Today',
        illustration: '📅',
        audio: 'Ba-bii'
    },

     'Bii wulafɛ (Après-midi)': {
        translation: 'Après-midi', translationEn: 'Afternoon',
        illustration: '📅'
    },
    'Sini (Demain)': {
        translation: 'Demain', translationEn: 'Tomorrow',
        illustration: '🌅',
        audio: 'Ba-sini'
    },

     'Sinikene (Après-Demain)': {
        translation: 'Après Demain', translationEn: 'The day after tomorrow',
        illustration: '🌅',
        audio: 'Ba-sinikene'
    },

     'Logokun tɛmɛnin (La semaine passée)': {
        translation: 'La semaine passée', translationEn: 'Last week',
        illustration: '🌅',
        audio: 'Ba-Logokun_temenin'
    },

    'Kalo tɛmɛnin (Le mois passé)': {
        translation: 'Le mois passé', translationEn: 'Last month',
        illustration: '🌅',
        audio: 'Ba-Kalo_temenin'
    },

     'Saan tɛmɛnin': {
        translation: 'Année passée', translationEn: 'Last year',
        illustration: '🌅',
        audio: 'Ba-Saan_temenin'
    },

     'Kalo wɛrɛ': {
        translation: 'Le mois prochain', translationEn: 'Next month',
        illustration: '🌅',
        audio: 'Ba-Kalo_were'
    },


      'Saan wɛrɛ': {
        translation: 'Année prochaine', translationEn: 'Next year',
        illustration: '🌅',
        audio: 'Ba-Saan_were'
    },

    'Kunu (Hier)': {
        translation: 'Hier', translationEn: 'Yesterday',
        illustration: '🌙',
        audio: 'Ba-kunu'
    },
  
    'Kununasini (Avant-hier)': {
        translation: 'Avant-hier', translationEn: 'The day before yesterday',
        illustration: '📅',
        audio: 'Ba-kununasini'
    },

    // Moments de la journée
    'Sɔgɔma (Matin)': {
        translation: 'Matin', translationEn: 'Morning',
        illustration: '🌄',
        audio: 'Ba-sogoma'
    },
    'Tile (Jour/Soleil)': {
        translation: 'Jour/Soleil', translationEn: 'Day/Sun',
        illustration: '☀️',
        audio: 'Ba-tile'
    },
    'Wula (Soir)': {
        translation: 'Soir', translationEn: 'Evening',
        illustration: '🌆',
        audio: 'Ba-wula'
    },
    'Su (Nuit)': {
        translation: 'Nuit', translationEn: 'Night',
        illustration: '🌙',
        audio: 'Ba-su'
    },
    'Tilegan (Midi)': {
        translation: 'Midi', translationEn: 'Noon',
        illustration: '🕛'
    },
    'Sutura (Crépuscule)': {
        translation: 'Crépuscule', translationEn: 'Dusk',
        illustration: '🌇',
        audio: 'Ba-sutura'
    },
    'Tilebintu (Coucher du soleil)': {
        translation: 'Coucher du soleil', translationEn: 'Sunset',
        illustration: '🌆'
    },
    'Tilebɔtu (Lever du soleil)': {
        translation: 'Lever du soleil', translationEn: 'Sunrise',
        illustration: '🌅'
    },

    // Périodes
    'Kalo (Mois/Lune)': {
        translation: 'Mois/Lune', translationEn: 'Month/Moon',
        illustration: '🌕',
        audio: 'Ba-kalo'
    },
    'Saan (Année)': {
        translation: 'Année', translationEn: 'Year',
        illustration: '📅',
        audio: 'Ba-saan'
    },
    'Dɔgɔkun (Semaine)': {
        translation: 'Semaine', translationEn: 'Week',
        illustration: '📅',
        audio: 'Ba-dogokun'
    },
    'Sanji (Saison des pluies)': {
        translation: 'Saison des pluies', translationEn: 'Rainy season',
        illustration: '🌧️',
        audio: 'Ba-sanji'
    },
    'Tilema (Saison sèche)': {
        translation: 'Saison sèche', translationEn: 'Dry season',
        illustration: '☀️'
    },
    'Fonɛnɛ (Saison fraîche)': {
        translation: 'Saison fraîche', translationEn: 'Cool season',
        illustration: '🍃'
    },
    'Samiya (Saison de transition)': {
        translation: 'Saison de transition', translationEn: 'Transition season',
        illustration: '🍂'
    },

    // Jours de la semaine
    'Lundi (Kobalon)': {
        translation: 'Lundi', translationEn: 'Monday',
        illustration: '1️⃣',
        audio: 'Ba-Kobalon'
    },
    'Mardi (Koolon)': {
        translation: 'Mardi', translationEn: 'Tuesday',
        illustration: '2️⃣',
        audio: 'Ba-Koolon'
    },
    'Mercredi (Kunulon)': {
        translation: 'Mercredi', translationEn: 'Wednesday',
        illustration: '3️⃣',
        audio: 'Ba-Kunulon'
    },
    'Jeudi (Bilon)': {
        translation: 'Jeudi', translationEn: 'Thursday',
        illustration: '4️⃣',
        audio: 'Ba-bilon'
    },
    'Vendredi (Sinilon)': {
        translation: 'Vendredi', translationEn: 'Friday',
        illustration: '5️⃣',
        audio: 'Ba-sinilon'
    },
    'Samedi (Kenelon)': {
        translation: 'Samedi', translationEn: 'Saturday',
        illustration: '6️⃣',
        audio: 'Ba-kenelon'
    },
    'Dimanche (Karilon)': {
        translation: 'Dimanche', translationEn: 'Sunday',
        illustration: '7️⃣',
        audio: 'Ba-Kaarilon'
    },

    // Mois de l'année
    'Janvier (Binnawulɛ)': {
        translation: 'Janvier', translationEn: 'January',
        illustration: '1️⃣',
        audio: 'Ba-Binnawule'
    },
    'Février (Kungogɛ)': {
        translation: 'Février', translationEn: 'February',
        illustration: '2️⃣',
        audio: 'Ba-Kungoge'
    },
    'Mars (Taraba)': {
        translation: 'Mars', translationEn: 'March',
        illustration: '3️⃣',
        audio: 'Ba-Taraba'
    },
    'Avril (Kungodibi)': {
        translation: 'Avril', translationEn: 'April',
        illustration: '4️⃣',
        audio: 'Ba-Kungodibi'
    },
    'Mai (Dabata)': {
        translation: 'Mai', translationEn: 'May',
        illustration: '5️⃣',
        audio: 'Ba-Dabata'
    },
    'Juin (Wɔsiwara)': {
        translation: 'Juin', translationEn: 'June',
        illustration: '6️⃣',
        audio: 'Ba-Wosiwara'
    },
    'Juillet (Karifɔ)': {
        translation: 'Juillet', translationEn: 'July',
        illustration: '7️⃣',
        audio: 'Ba-Karifo'
    },
    'Août (Dababila)': {
        translation: 'Août', translationEn: 'August',
        illustration: '8️⃣',
        audio: 'Ba-Dababila'
    },
    'Septembre (Tulafin)': {
        translation: 'Septembre', translationEn: 'September',
        illustration: '9️⃣',
        audio: 'Ba-Tulafin'
    },
    'Octobre (Kɔmiji)': {
        translation: 'Octobre', translationEn: 'October',
        illustration: '🔟',
        audio: 'Ba-Komiji'
    },
    'Novembre (Nɛnɛba)': {
        translation: 'Novembre', translationEn: 'November',
        illustration: '1️⃣1️⃣',
        audio: 'Ba-Neneba'
    },
    'Décembre (Kolinkolin)': {
        translation: 'Décembre', translationEn: 'December',
        illustration: '1️⃣2️⃣',
        audio: 'Ba-Kolinkolin'
    },

    // Expressions temporelles
    'Sisan (Maintenant)': {
        translation: 'Maintenant', translationEn: 'Now',
        illustration: '⌚',
        audio: 'Ba-sisan'
    },
    'Kɔfɛ (Plus tard)': {
        translation: 'Plus tard', translationEn: 'Later',
        illustration: '⏳',
        audio: 'Ba-kofe'
    },
    'Kɔrɔ (Avant)': {
        translation: 'Avant', translationEn: 'Before',
        illustration: '⏮️',
        audio: 'Ba-koro'
    },
    'Joona (Tôt/Vite)': {
        translation: 'Tôt/Vite', translationEn: 'Early/Fast',
        illustration: '⏱️'
    },
    'Sumaya (Lentement)': {
        translation: 'Lentement', translationEn: 'Slowly',
        illustration: '🐢'
    },
    'Tuma bɛɛ (Toujours)': {
        translation: 'Toujours', translationEn: 'Always',
        illustration: '♾️'
    }
};

export default temps;
export {};
